import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function FinalCtaSection() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl rounded-2xl border border-background-200 bg-background-50 px-6 py-12 text-center md:px-12">
        <span className="mx-auto flex w-14 h-14 items-center justify-center rounded-full bg-accent-100 text-accent-900">
          <i className="ri-rocket-2-line text-2xl"></i>
        </span>
        <h2 className="mt-5 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {t("final.title")}
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
          {t("final.subtitle")}
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          {t("final.button")}
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-up-line"></i>
          </span>
        </a>
      </div>
    </section>
  );
}